/** @jsx jsx */
import SEO from '../components/seo'
import { jsx } from 'theme-ui'
import rocketBackground from '../components/info/rocketBackground.png'
import InfoPageFrame from '../components/info/InfoPageFrame'
import RedirectCounter from '../components/info/RedirectCounter'
import UnauthenticatedLayout from '../components/UnauthenticatedLayout'

const LogInRedirect = () => {
  const redirectUrl = process.env.GATSBY_AUTH_REDIRECT_LINK
  const handleClick = () => (window.location.href = redirectUrl)

  const actionButton = {
    name: "Let's Go!",
    handleClick: handleClick,
  }

  return (
    <UnauthenticatedLayout>
      <SEO title="Log In Redirect" />
      <InfoPageFrame
        title=" Oops!"
        subTitle="You are required to sign in through COMMunityLink."
        desktopBackgroundImg={rocketBackground}
        actionButton={actionButton}
        sx={{ mt: 4 }}
      >
        You will be redirected to COMMunity Link in{' '}
        <RedirectCounter countDownFrom={5} redirectUrl={redirectUrl} />, or you
        may click the button below.
      </InfoPageFrame>
    </UnauthenticatedLayout>
  )
}

export default LogInRedirect
